module.exports = __webpack_public_path__ + "img/interrogacao.fc64d747.png";